import { axiosApiInstance } from './axios';

// -------------------------------------------------------------

const apiRoot = '';

const summaryDepartmentRequestsApi = {
  // GET
  getByDepartmentRequestId: async (id) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/departmentRequests/v2/summary-status/${id}`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};

export default summaryDepartmentRequestsApi;
